import React, { useState } from 'react';
import Eye from "../../assets/icons/visibility-on.svg"
import EyeCut from "../../assets/icons/visibility-off.svg"
import "../../styles/componentsStyles/ManageAccount/Password.scss"

const Password = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);


    const handleToggleCurrentPassword = () => {
        setShowCurrentPassword(!showCurrentPassword);
    };

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleToggleConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'currentPassword') setCurrentPassword(value);
        if (name === 'newPassword') setNewPassword(value);
        if (name === 'confirmPassword') setConfirmPassword(value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Validate password fields
        if (!currentPassword || !newPassword || !confirmPassword) {
            setErrorMessage('All fields are required');
            return;
        }
        if (newPassword !== confirmPassword) {
            setErrorMessage('New password and confirm password must match');
            return;
        }
        // Code to handle password change
        // API call to update the password
        console.log('Password changed successfully');
        // Clear form fields
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setErrorMessage('');
    };


    return (
        <div className='password-edit'>
            <h2 className='password-edit__title'>Change Password</h2>
            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
            <form onSubmit={handleSubmit}>
                <div className='password-edit__input-group'>
                    <label htmlFor="currentPassword">Current Password:</label>
                    <div className="password-edit__password-container">
                        <input
                            type={showCurrentPassword ? 'text' : 'password'}
                            id="currentPassword"
                            name="currentPassword"
                            value={currentPassword}
                            onChange={handleChange}
                            autoFocus
                        />
                        <button type="button" onClick={handleToggleCurrentPassword}>
                            {showCurrentPassword ? <img src={Eye} alt="show" /> : <img src={EyeCut} alt="hide" />}
                        </button>
                    </div>
                </div>
                <div className='password-edit__input-group'>
                    <label htmlFor="newPassword">New Password:</label>
                    <div className="password-edit__password-container">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id="newPassword"
                            name="newPassword"
                            value={newPassword}
                            onChange={handleChange}
                        />
                        <button type="button" onClick={handleTogglePassword}>
                            {showPassword ? <img src={Eye} alt="show" /> : <img src={EyeCut} alt="hide" />}
                        </button>
                    </div>
                </div>
                <div className='password-edit__input-group'>
                    <label htmlFor="confirmPassword">Confirm New Password:</label>
                    <div className="password-edit__password-container">
                        <input
                            type={showConfirmPassword ? 'text' : 'password'}
                            id="confirmPassword"
                            name="confirmPassword"
                            value={confirmPassword}
                            onChange={handleChange}
                        />
                        <button type="button" onClick={handleToggleConfirmPassword}>
                            {showConfirmPassword ? <img src={Eye} alt="show" /> : <img src={EyeCut} alt="hide" />}
                        </button>
                    </div>
                </div>
                <button type="submit" className='password-edit__submit-btn'>Change Password</button>
            </form>
        </div>
    );
};

export default Password;
